import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { DocumentVaultState, UploadFileData } from './reducer';
import { StateParams } from './actions';
import { FilterableYearOption } from '../DocumentVault.meta';

const documentVaultState = state => state.documentVault;

export const uploadingFilesSelector = createSelector(
  documentVaultState,
  ({ uploadingFiles }) => uploadingFiles,
);

export const isWorkflowSelector = createSelector(
  documentVaultState,
  ({ isWorkflow }) => isWorkflow,
);

export const stateParamsSelector = createSelector(
  documentVaultState,
  ({ stateParams }) => stateParams,
);

export const selectFidelityFilterableYearOption = createSelector(
  documentVaultState,
  ({ fidelityFilterableYearOption }) => fidelityFilterableYearOption,
);

export const useUploadingFiles = (): Record<string, UploadFileData> => {
  return useSelector(uploadingFilesSelector);
};

export const useIsWorkflow = (): boolean => {
  return useSelector(isWorkflowSelector);
};

export const useStateParams = (): StateParams => {
  return useSelector(stateParamsSelector);
};

export const selectFilePendingConfirmation = createSelector(
  (state: { documentVault: DocumentVaultState }) => state.documentVault,
  ({ filePendingConfirmation }) => filePendingConfirmation,
);

export const useFilterableYearOption = (): FilterableYearOption => {
  return useSelector(selectFidelityFilterableYearOption);
};
